import { Box, Tooltip, Typography } from "@mui/material";
import { AddHomeOutlined, History } from "@mui/icons-material";
import { useEffect, useState } from "react";
import SiteStatusIcon from "./SiteStatusIcon";
import { fromNow } from "utils/datetime";

const SiteStatusIconGroup = ({ status, wrapperClass = "flex-end" }) => {
  const [selectedUnit, setSelectUnit] = useState({});

  useEffect(() => {
    if (status.id !== selectedUnit?.id) {
      setSelectUnit(status);
    }
  }, [status]);

  const getValue = (value) =>
    value && !isNaN(value) ? value.toFixed(1) : (value ?? 0);

  const getPower = (value) =>
    !value ? "0.0kW" : (value / 1000).toFixed(1) + "kW";

  const getSolarType = (v) => (!v || v < 50 ? "solarHallow" : "solar");
  const getBatteryType = (v) => (v < -100 ? "battery" : "batteryFull");

  return (
    <Box
      className={`status-icon-group items-center ${wrapperClass}`}
      sx={{ width: "100%" }}
    >
      <Box className="items-center">
        <SiteStatusIcon
          type={"noop"}
          value1={status?.details?.dex_id ? "deX" : ""}
          value2={
            status?.detail?.control_mode === "vpp"
              ? "VPP"
              : status?.detail?.control_mode === "optimisation"
                ? "iQ"
                : ""
          }
          width="unset"
        />

        {/* GRID */}
        <SiteStatusIcon
          type="grid"
          value1={getValue(status?.grid_voltage) + "V"}
          value2={getValue(getPower(status?.grid_power))}
          status={status}
        />

        {/* SOLAR */}
        {status?.pv_power_internal != null ||
        status?.pv_power_external != null ? (
          <SiteStatusIcon
            type={getSolarType(status?.solar_power)}
            value1={
              status?.pv_power_internal != null
                ? getValue(getPower(status?.pv_power_internal))
                : "-"
            }
            value2={
              status?.pv_power_external != null
                ? getValue(getPower(status?.pv_power_external))
                : "-"
            }
            tooltips={[
              "Solar Power Internal (DC Coupled)",
              "Solar Power External (AC Coupled)",
            ]}
          />
        ) : (
          <SiteStatusIcon
            type={getSolarType(status?.solar_power)}
            value2={getValue(getPower(status?.solar_power))}
            tooltips={["Solar Power"]}
          />
        )}

        {/* BATTERY */}
        <SiteStatusIcon
          type={getBatteryType(status?.battery_power)}
          value1={getValue(status?.battery_soc) + "%"}
          value2={getValue(getPower(status?.battery_power))}
          tooltips={["Battery State of Charge", "Battery Power"]}
        />

        {/* SITE CREATED */}
        <Tooltip title="Site Created" placement="top" arrow>
          <Box className="items-center" sx={{ width: "132px" }}>
            <AddHomeOutlined />
            <Typography variant="body2" ml={1}>
              {status?.details?.created_at ? fromNow(status?.details?.created_at * 1000) : "-"}
            </Typography>
          </Box>
        </Tooltip>

        {/* LAST SEEN */}
        <Tooltip title="Last Seen" placement="top" arrow>
          <Box className="items-center" sx={{ width: "132px" }}>
            <History />
            <Typography variant="body2" ml={1}>
              {status?.last_update ? fromNow(status?.last_update * 1000) : "-"}
            </Typography>
          </Box>
        </Tooltip>
      </Box>
    </Box>
  );
};

export default SiteStatusIconGroup;
